import { BookLanguage, Language } from '../../../rest/models';
import { ModelMap } from '../../../rest/slice';
import { SourceLanguageEdit } from './languages/SourceLanguageEdit';
import { TranslationLanguagesEdit } from './languages/TranslationLanguagesEdit';
import { LanguageOrderEdit } from './languages/LanguageOrderEdit';

export function BookLanguagesEdit(props: Props)
{
    const {source_language, book_languages, lang_models} = props;    

    return (
        <div className='ernots_BookLanguagesEdit'>
            <p>
                Now you will configure the book's languages. Set the text's source language
                and one or more languages to translate it into. 
            </p>

            <SourceLanguageEdit
                source_language={source_language}/>
            <br/>
            <TranslationLanguagesEdit
                source_language={source_language}
                book_languages={book_languages}
                lang_models={lang_models}/>
            <br/>
            <LanguageOrderEdit
                book_languages={book_languages}
                lang_models={lang_models}/>
        </div>);
}

interface Props
{
    source_language: string;
    book_languages: BookLanguage[];
    lang_models: ModelMap<Language>;
}